import styled from 'styled-components';

const orangeColor = '#f96303';
const hoverOrangeColor = '#d55501';
const darkOrangeColor = '#c14c00';
const disabledColor = '#999999';

export default styled.div`
  button.primary {
    font-weight: bold;
    color: #fff;
    box-shadow: 0 3px 0 0 ${darkOrangeColor};
    background-color: ${orangeColor};
    border: none;
    outline: none;
    &:hover {
      background-color: ${hoverOrangeColor};
    }
    &:disabled {
      background-color: #cccccc;
      box-shadow: 0 3px 0 0 ${disabledColor};
      color:  ${disabledColor};
    }
  }

  button.secondary {
    font-weight: bold;
    color: #f96302;
    background-color: #fff;
    border: 2px solid ${orangeColor};
    outline: none;
    &:hover {
      color: #fff;
      background-color: ${orangeColor};
    }
  }
`;
